import { XStack } from '@shinetools/lumen-react'
import { MouseEvent, ReactElement, useCallback } from 'react'

import { SupplierActionsMenu } from '@views/suppliers/elements/SupplierActionsMenu'

import { SuppliersTableRow } from '../../types/suppliersTableRow'

interface SuppliersTableActionsCellProps {
  row: SuppliersTableRow
}

export const SuppliersTableActionsCell = ({ row }: SuppliersTableActionsCellProps): ReactElement => {
  const handleActionsCellClick = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }, [])

  return (
    <XStack align="center" onClick={handleActionsCellClick}>
      <SupplierActionsMenu
        contact={{ id: row.id, name: row.name ?? '', organizationId: row.organizationId }}
        placement="bottom-end"
        triggerVariant="text"
      />
    </XStack>
  )
}
